import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UnsavedSceneService {

  public hasSceneBeenSaved = true;

  constructor() { }

  setHasSceneBeenSaved(hasSceneBeenSaved){
    //this.hasSceneBeenSaved = hasSceneBeenSaved;
  }

  getHasSceneBeenSaved(){
    return this.hasSceneBeenSaved;
  }
}
